import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '../../authApiService';
import { PaymentDetailsGeneralType } from '@/types/paymentDetailsTypes';

export const getDepositorPaymentDetailsApi = (id: string): Promise<ApiResponseType<PaymentDetailsGeneralType>> => {
  const uri = `/depositor/wires/${id}/payment-details/`;

  return authApiService.GET(uri);
};
